import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCalendarX = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 15 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.688.5c.518 0 .937.419.937.938v.937h3.75v-.938a.936.936 0 1 1 1.875 0v.938h1.406c.777 0 1.406.63 1.406 1.406v1.406H.938V3.782c0-.776.63-1.406 1.406-1.406H3.75v-.938C3.75.92 4.169.5 4.688.5ZM.938 6.125h13.124v7.969c0 .776-.63 1.406-1.406 1.406H2.344c-.777 0-1.406-.63-1.406-1.406V6.125Zm8.935 3.31a.703.703 0 0 0-.993-.993L7.503 9.82 6.126 8.442a.703.703 0 0 0-.993.993l1.377 1.377-1.377 1.378a.703.703 0 0 0 .993.993l1.377-1.377 1.377 1.377a.703.703 0 0 0 .993-.993l-1.377-1.377 1.377-1.377Z"
	})
});
export default SvgIconCalendarX;
